import React       from "react";
import PropTypes   from 'prop-types';
import Constants, {getTypeByColor}   from './Constants';
import Flux        from '../../flux/Flux';
import {setCookie} from "../../utils/CommonUtils";
import Alert from "../Alert/Alert";

export default class StatusBarMonthlyBonusNotification extends React.Component {

	constructor(props) {
		super(props);
		this.state             = {
			isVisible: props.isVisible,
		};
		this.removeStatusBar   = this.removeStatusBar.bind(this);
		this.monitorHrefChange = this.monitorHrefChange.bind(this);
		this.href              = location.href;
	}

	UNSAFE_componentWillMount() {
		this.timeIntervalID = setInterval(this.monitorHrefChange, 4000);
	}

	monitorHrefChange() {
		if (this.href !== location.href) {
			this.removeStatusBar();
			clearInterval(this.timeIntervalID);
			setCookie(Flux.Constants.CookieNames.STATUS_BAR_MONTHLY_BONUS, '1', 5, '/', '', true, Flux.Constants.CookieSameSiteAttributes.LAX);
		}
	}

	removeStatusBar() {
		this.setState({
			isVisible: false,
		});
	}

	render() {
        if (!this.state.isVisible) {
            return null;
        }
        return <Alert
            type={getTypeByColor(this.props.barColor)}
            text={this.props.msgOutro}
        />;
	}
}

StatusBarMonthlyBonusNotification.propTypes = {
	barColor:           PropTypes.string.isRequired,
	msgOutro:           PropTypes.string.isRequired,
	isVisible:          PropTypes.bool.isRequired,
};

StatusBarMonthlyBonusNotification.defaultProps = {
	barColor: Constants.BARCOLOR_GREEN,
};
